module.exports = ".category-tree {\n  border: 1px solid #ededed;\n  background: #ffffff;\n  padding: 15px;\n  border-top-width: 0px; }\n\n.select-categories {\n  cursor: pointer;\n  height: auto; }\n\n.select-categories span {\n    line-height: 1.5em; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/elements/components/tree/tree.component.scss
// module id = ./libs/chassis-core/src/app/forms/elements/components/tree/tree.component.scss
// module chunks = main